/**
 * Duyuru çubuğu için kesintisiz kayan bant (marquee) davranışı.
 *
 * Liquid tarafı duyuru metinlerini tek sefer render eder; bu bileşen bu
 * içeriği, şerit ekran genişliğini en az bir tam kopya kadar aşacak şekilde
 * yeterince çoğaltır. CSS animasyonu (`announcement-marquee-scroll`) şeridi
 * tam bir kopya genişliği (-100% / kopya sayısı) kaydırır; böylece bant hiç
 * boşluk veya sıçrama olmadan sonsuz döngü halinde akar. Kopya sayısı, kısa
 * duyurularda geniş ekranda şeridin boşalıp baştan başlamasını önler.
 */
class AnnouncementMarqueeComponent extends HTMLElement {
  /** @type {HTMLElement | null} */
  track = null;
  /** @type {HTMLElement[]} */
  originals = [];
  /** @type {ResizeObserver | null} */
  observer = null;
  lastWidth = 0;

  connectedCallback() {
    const track = /** @type {HTMLElement | null} */ (this.querySelector('.announcement-bar__slides'));
    if (!track || track.dataset.duplicated === 'true') return;

    this.track = track;
    this.originals = /** @type {HTMLElement[]} */ (Array.from(track.children));
    if (this.originals.length === 0) return;

    // Kayan bantta tüm duyurular aynı anda görünür; crossfade moduna özel
    // aria-hidden değerlerini kaldırıyoruz.
    this.originals.forEach((slide) => slide.removeAttribute('aria-hidden'));

    this.fill();

    // Font yüklenince metin genişliği değişir; ekran döndürme/yeniden
    // boyutlandırmada da kopya sayısını yeniden hesapla.
    this.observer = new ResizeObserver(() => {
      if (this.clientWidth !== this.lastWidth) this.fill();
    });
    this.observer.observe(this);
    if (document.fonts?.ready) document.fonts.ready.then(() => this.fill());
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  fill() {
    const track = this.track;
    if (!track) return;

    this.lastWidth = this.clientWidth;

    // Kopyaları temizleyip yalnızca orijinallerle ölç.
    Array.from(track.children).forEach((el) => {
      if (!this.originals.includes(/** @type {HTMLElement} */ (el))) el.remove();
    });
    delete track.dataset.duplicated;

    const setWidth = track.scrollWidth;
    if (!setWidth) return;

    // En az 2 kopya; şerit, görünür alanın 1 kopya fazlasını kaplamalı ki
    // -100%/kopya kaydırması sırasında sağ taraf asla boş kalmasın.
    const copies = Math.max(2, Math.ceil(this.clientWidth / setWidth) + 1);

    for (let i = 1; i < copies; i++) {
      this.originals.forEach((slide) => {
        const clone = /** @type {HTMLElement} */ (slide.cloneNode(true));
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }

    track.style.setProperty('--marquee-copies', String(copies));
    track.dataset.duplicated = 'true';
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementMarqueeComponent);
}
